class EntitlementsModel {
    constructor (data) {
        this.data = data || {};
        this.entitlementCodes;
        this.parseData();
    }

    parseData () {
        const contents = this.data?.contents;
        const hasContents = contents && Array.isArray(contents);

        if (hasContents) {
            let temp = [];
            contents.forEach(element => {
                const { entitlementCode, isActive } = element;
                if (isActive && entitlementCode) {
                    temp.push(entitlementCode);
                }
            });
    
            this.entitlementCodes = new Set(temp);
        }
        
    }
}

export default EntitlementsModel;
  